<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.mainjoin
	background:#F9F9F9;
	.top
		width:100%;
		height:492px;
		position: relative;
		background:url('../../../static/img/joinus.png') no-repeat;
		background-size: 100% 100%;
		.top-main
			position: absolute;
			bottom:50px;
			right:90px;
			color:#fff;
			font-size:48px;
	.center
		text-align:center;
		padding:55px 0px;
		.c-title
			border-bottom:1px solid #CECECE;
			font-size:22px;
			font-weight: 500;
			color:#000000;
		.c-title-english
			color:#8D8D8D;
			height:20px;
			line-height:20px;
			font-size: 14px;
	.joinlist
		padding-bottom:100px;
		.lists
			margin:30px auto;
			width:1047px;
			min-height:150px;
			background:#FFFFFF;
			border-radius:8px;
			.list
				display:flex;
				justify-content:space-between;
				padding:30px 50px;
				position: relative;
				.l-left
					display:flex;
					width:70%;
					.l-left-l
						width:20%;
						.l-left-l-title
							color:#000000;
							font-size:18px;
							font-weight:500;
						.l-left-l-desc
							display:flex;
							align-items:center;
							color:#000000;
							font-size:16px;
							margin-top:5px;
							.l-left-l-dian
								width:4px;
								height:4px;
								border-radius:50%;
								background:#2751CB;
								margin-right:5px;
					.l-left-r
						width:70%;
						.l-left-r-main
							display:flex;
							color:#040B21;
							font-size:16px;
							div
								margin-right:20px;
						.l-left-r-title
							color:#071336;
							font-size:14px;
						.l-left-r-content
							color:#666666;
							font-size:14px;
							line-height: 24px;
							white-space: pre-line;
							word-break: break-word;
							word-wrap: break-word;
							transition: all .3s;
		                .comeHeight
							height 70px;
							overflow: hidden;
							text-overflow: ellipsis;
				.l-right
					width:10%;
					color:#1890ff;
					font-size:18px;
				.activeBtn
					position: absolute;
					bottom: -15px;
					left: 50%;
					transform :translate(-50%);
					cursor: pointer;
</style>
<template>
  <div class="mainjoin">
    <div class="top">
    	<div class="top-main">
    		<div>虚位以待您的加入</div>
    	</div>
    </div>
    
    <div class="center">
    	<div class="c-title">招聘职位</div>
    	<div class="c-title-english">Jobs recruitment</div>
    </div>

    <div class="joinlist">
    	<div v-for="(item,index) in joinList" class="lists">
    		<div class="list">
    			<div class="l-left">
    				<div class="l-left-l">
    					<div class="l-left-l-title">{{item.position}}</div>
    					<div class="l-left-l-desc"><div class="l-left-l-dian"></div><div>职位描述</div></div>
    				</div>
    				<div class="l-left-r">
    					<div class="l-left-r-main">
    						<div>城市：{{item.city}}</div>
    						<div>经验：{{item.occupational_history}}</div>
    						<div>学历：{{item.education_background}}</div>
    					</div>
    					<div class="l-left-r-content" :class="item.active ? '':'comeHeight'">{{item.content}}</div>
    				</div>
    			</div>
    			<div class="l-right">薪资：{{item.compensation}}</div>
    			<div class="activeBtn" @click="tabList(item, index)">
                    <img src="/static/img/unfold.png" v-if="!item.active">
                    <img src="/static/img/fold.png"  v-else>
                </div>
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'joinUs',
  data () {
    return {
      joinList:[]
    }
  },
  mounted(){
  	this.getList();
  },
  methods:{
  	getList(){
  		axios.get('https://api.honsenflag.cn/hp/recruitment/list',{params: {page: 1, perpage: 12}}).then(res =>{
  			res.data.data.data.forEach(e => e.active = false);
  			this.joinList = res.data.data.data;
  		})
  	},
  	tabList(item, index) {
        item.active = !item.active         
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/aboutHonsen/joinUs.vue